import React from "react";
import TextsmsIcon from "@mui/icons-material/Textsms";
import NotificationsIcon from "@mui/icons-material/Notifications";
import "./Header.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Domain } from "../URLs/Domain";
import { ImageChecker } from "./ImageChecker";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname.split("/").filter(Boolean);

  const { user } = useSelector((state) => state.auth);
  const profilePath = user?.operator?.profile_photo_path?.replace(/^\/+/, "");
  const profileUrl = `${Domain.replace(/\/+$/, "")}/${profilePath}`;

  return (
    <>
      <div className="pageHeader border-bottom">
        <div className="title m-left-20">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-header">
              <li
                onClick={() => navigate("/")}
                className="breadcrumb-item cursor"
              >
                Home
              </li>
              {path.map((e, i) => {
                const subPath = "/" + path.slice(0, i + 1).join("/");
                const formatted = decodeURIComponent(e.replace(/-/g, " "));
                return (
                  <li
                    key={i}
                    className={`breadcrumb-item cursor ${
                      i === path.length - 1 ? "active" : ""
                    }`}
                    onClick={() => navigate(subPath)}
                  >
                    {formatted}
                  </li>
                );
              })}
            </ol>
          </nav>
        </div>

        <div className="headerInfo">
          <div className="userHeaderIcon">
            <TextsmsIcon />
          </div>
          <div className="userHeaderIcon">
            <NotificationsIcon />
          </div>
          <div className="userImag">
            <ImageChecker profilePhoto={profileUrl} />
          </div>
          <div className="userInfo">
            <div className="userInfo-username">{user?.operator?.name}</div>
            <div className="userInfo-userRow">
              {user?.operator?.roles[0]?.name}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
